import { Link } from 'react-router-dom';
import { tr } from '@/contexts/LanguageContext';

/** Enlaces legales reutilizables (footer, registro, checkout). Públicos: no requieren sesión. */
export const LEGAL_PATHS = {
  terms: '/legal/terminos',
  privacy: '/legal/privacidad',
  contact: '/legal/contacto',
};

export const LegalLinks = ({ className = '', testid = 'legal-links', compact = false }) => (
  <nav className={`flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-muted-foreground ${className}`} data-testid={testid} aria-label={tr("Legal")}>
    <Link to={LEGAL_PATHS.terms} className="hover:text-primary transition-colors underline-offset-2 hover:underline" data-testid={`${testid}-terms`}>{tr("Términos de Servicio")}</Link>
    <span aria-hidden>·</span>
    <Link to={LEGAL_PATHS.privacy} className="hover:text-primary transition-colors underline-offset-2 hover:underline" data-testid={`${testid}-privacy`}>{tr("Política de Privacidad")}</Link>
    {!compact && (
      <>
        <span aria-hidden>·</span>
        <Link to={LEGAL_PATHS.contact} className="hover:text-primary transition-colors underline-offset-2 hover:underline" data-testid={`${testid}-contact`}>{tr("Contacto")}</Link>
      </>
    )}
  </nav>
);

/** Línea corta para pantallas de pago: «Al pagar aceptas los Términos y la Privacidad». */
export const CheckoutLegalNote = ({ testid = 'checkout-legal-note', verb = 'pagar' }) => (
  <p className="text-[10px] text-muted-foreground text-center mt-2 leading-snug" data-testid={testid}>{tr("Al {0} aceptas los", tr(verb))}{' '}
    <Link to={LEGAL_PATHS.terms} className="text-primary underline underline-offset-2" data-testid={`${testid}-terms`}>{tr("Términos de Servicio")}</Link>{' '}{tr("y la")}{' '}
    <Link to={LEGAL_PATHS.privacy} className="text-primary underline underline-offset-2" data-testid={`${testid}-privacy`}>{tr("Política de Privacidad")}</Link>.
  </p>
);

export default LegalLinks;
